import React, { useEffect, useState } from "react";
import FormSkel from "./FormSkel";

export default function NotificationForm({
    handleClose,
    handleSubmit,
    notification,
    levels
}) {
    const defaultData = {
        NotificationId: "",
        UserNotificationLevelId: ""
    };

    const [data, setData] = useState(defaultData);
    const [changed, setChanged] = useState(false);

    useEffect(() => {
        if (notification) {
            const startLevel =
                notification.UserNotificationLevelId ??
                notification.DefaultNotificationLevelId ??
                "";

            setData({
                NotificationId: notification.NotificationId,
                UserNotificationLevelId: startLevel
            });
        }
    }, [notification]);

    const onChange = (e) => {
        const { name, value } = e.target;
        setChanged(true);
        setData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <FormSkel
            headerText={"Edytuj powiadomienie"}
            handleClose={handleClose}
            disableSubmit={!changed}
            data={data}
            disableClose={false}
            noFooter={false}
        >
            <form
                id="modal-form"
                onSubmit={(e) => handleSubmit(e, data)}
                onKeyDown={(evt) => evt.key === "Enter" && evt.preventDefault()}
            >
                <div className="mb-3">
                    <label className="h6">Nazwa powiadomienia</label>
                    <input
                        className="form-control"
                        name="NotificationName"
                        value={notification?.NotificationName ?? ""}
                        disabled
                    />
                </div>
                <div className="mb-3">
                    <label className="h6">Poziom użytkownika</label>
                    <select
                        className="form-control"
                        name="UserNotificationLevelId"
                        value={data.UserNotificationLevelId}
                        onChange={onChange}
                    >
                        {levels.map(l => (
                            <option
                                key={l.NotificationLevelId}
                                value={l.NotificationLevelId}
                            >
                                {l.Name}
                            </option>
                        ))}
                    </select>
                </div>
            </form>
        </FormSkel>
    );
}
